import { warn } from "@/lib/log";
import { useEffect, useRef } from "react";

// Streams interim browser speech recognition while the user is talking.
export function useLiveCaption(locale, active, onCaption) {
  const cb = useRef(onCaption);
  cb.current = onCaption;
  // On mobile, speech recognition takes the mic exclusively and the voice recorder would capture silence.
  const isMobile = typeof navigator !== "undefined" && /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
  const SR = !isMobile && typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);

  useEffect(() => {
    if (!active || !SR) return undefined;
    const r = new SR();
    r.lang = locale;
    r.interimResults = true;
    r.continuous = true;
    let last = 0;
    let pending = null;
    let timer = null;
    const flush = () => {
      last = Date.now();
      timer = null;
      cb.current(pending);
    };
    r.onresult = (e) => {
      pending = Array.from(e.results).map((x) => x[0].transcript).join(" ").trim();
      if (Date.now() - last > 250) flush();
      else if (!timer) timer = setTimeout(flush, 250);
    };
    r.onerror = (e) => warn("Live caption error", e.error);
    try { r.start(); } catch (e) { warn("Live caption start failed", e); }
    return () => {
      clearTimeout(timer);
      try { r.stop(); } catch (e) { warn("Live caption stop failed", e); }
    };
  }, [active, locale, SR]);

  return !!SR;
}
